import axios from "axios";
import store from "../store";
import { authConstants } from "../actions/constants";
import storage from "../utils/storage";

const axiosInstance = axios.create({
  withCredentials: false,
  headers: { "X-Comput-Web": "1" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const localDevelopment = ["localhost", "127.0.0.1"].includes(window.location.hostname);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL
      || (localDevelopment ? "http://localhost:8000/api/v1" : storage.getItem("API_BASE_URL"));

    const user = store.getState().auth.user;
    const inAdminPortal = window.location.hash.startsWith("#/admin/");
    config.baseURL = user?.role === "employee" && inAdminPortal && !config.memberRequest
      ? `${apiBaseUrl}/reviewer-admin` : apiBaseUrl;
    config.headers["X-Request-ID"] = window.crypto?.randomUUID?.()
      || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    if (window.location.hash.split("?")[0] === "#/resource/addtime") {
      config.headers["X-Comput-Page"] = "/resource/addtime";
    }
    const token = localStorage.getItem("authToken");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    else delete config.headers.Authorization;
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response ? error.response.status : null;
    console.error("API_REQUEST_FAILED", {
      requestId: error.response?.headers?.["x-request-id"] || error.config?.headers?.["X-Request-ID"],
      method: error.config?.method,
      path: error.config?.url?.split("?")[0],
      status,
      code: error.code,
    });

    if (status === 403 && error.response?.data?.code === "REVIEWER_ACCESS_DENIED") {
      store.dispatch({ type: "REFRESH_ADMIN_ACCESS", payload: false });
      window.location.hash = "#/resource/addtime";
      return Promise.reject(error);
    }
    // Permission failures do not invalidate the user's session.
    if (status === 401 && !error.config?.skipSessionRedirect) {
      storage.removeItem("authToken");
      storage.removeItem("token");
      storage.removeItem("user");
      store.dispatch({ type: authConstants.LOGOUT_SUCCESS });
      window.location.hash = "#/";
      return Promise.reject(error);
    }

    // For any other error (400, 404, 500, network), show a toast
    // let message;
    // if (error.response && error.response.data?.error) {
    //   message = error.response.data.error;
    // } else if (error.response) {
    //   message = `Error ${error.response.status}: ${error.response.statusText}`;
    // } else {
    //   message = error.message || "Network error";
    // }

    // toast.error(message, {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    // });

    return Promise.reject(error);
  }
);

export default axiosInstance;

// import axios from "axios";
// import store from "../store";
// import { authConstants } from "../actions/constants";
// import storage from "../utils/storage"; // Import the storage utility

// // Helper function to retrieve the auth token
// const getToken = () => {
//   const token = storage.getItem("authToken");
//   return token ? token : null;
// };

// // Create an Axios instance without setting a static baseURL
// const axiosInstance = axios.create({
//   // baseURL will be set dynamically in the request interceptor
//   headers: {
//     Authorization: getToken() ? `Bearer ${getToken()}` : "",
//   },
// });

// // Request interceptor to set baseURL and Authorization header dynamically
// axiosInstance.interceptors.request.use(
//   (config) => {
//     // Retrieve the API base URL from localStorage
//     const apiBaseUrl = "http://localhost:8000/api/v1";
//     // const apiBaseUrl = storage.getItem("API_BASE_URL");

//     if (apiBaseUrl) {
//       config.baseURL = apiBaseUrl;
//       // console.log(`Setting baseURL to: ${apiBaseUrl}`); // Debugging
//     } else {
//       // console.warn("API_BASE_URL is not set in localStorage.");
//       // Optionally, set a default baseURL or handle the absence accordingly
//       // config.baseURL = 'https://default.api.com';
//     }

//     // Retrieve the latest auth token before each request
//     const token = getToken();
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     } else {
//       delete config.headers.Authorization; // Remove Authorization header if no token
//     }

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Response interceptor to handle global errors
// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     console.error("API Response Error:", error.response);

//     const status = error.response ? error.response.status : null;
//     if (status === 500) {
//       // Clear all stored data and dispatch logout action
//       storage.clear();
//       store.dispatch({ type: authConstants.LOGOUT_SUCCESS });
//       // Optionally, redirect the user to the login page
//       window.location.hash = "#/"; // Adjust the path as needed
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;
